import "./assets/sass/app.scss"; // メインCSS

import Swiper from 'swiper';
import { Navigation,Pagination,EffectFade } from 'swiper/modules';

import 'swiper/scss';
import 'swiper/css/effect-fade';

import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";



// init Swiper:
const swiper01 = new Swiper('.concept-swiper', {
    modules: [Navigation, Pagination,],
    slidesPerView: 1,
    breakpoints: {
        768: {
            slidesPerView: 3,
            spaceBetween:40,
        },
    },
    slideVisibleClass: 'visible',
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination:{
        el: '.swiper-pagination',
        clickable: true,
        type:'fraction',
        renderFraction: function renderFraction(currentClass, totalClass) {
            return `<span class="customPagenation"><span class="${currentClass}"></span> / <span class="${totalClass}"></span></span>`;
        },
    },
});

const swiper02 = new Swiper('.player-swiper', {
    modules: [Navigation,Pagination],
    slidesPerView: 1,
    spaceBetween:100,
    breakpoints: {
        768: {
            slidesPerView: 3.5,
            spaceBetween:40,
        },
    },
    slideVisibleClass: 'visible',
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination:{
        el: '.swiper-pagination',
        clickable: true,
        type:'fraction',
        renderFraction: function renderFraction(currentClass, totalClass) {
            return `<span class="customPagenation"><span class="${currentClass}"></span> / <span class="${totalClass}"></span></span>`;
        },
    },
});

const swiper03 = new Swiper('.size-swiper', {
    modules: [Pagination,EffectFade],
    slidesPerView: 1,
    spaceBetween:0,
    effect: 'fade',
    speed: 1000, 
    pagination:{
        el: '.swiper-pagination',
        clickable: true,
    },
});



const boxes = document.querySelectorAll('.aniTrigger');

function doWhenIntersect(entries) {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add("is-active");
        // }else {
        //     entry.target.classList.remove("is-active");
        }
    });
}

const options = {
    root : null,
    rootMargin: "0px 0px -20% 0px",
    threshold: 0
};

const observer = new IntersectionObserver(doWhenIntersect, options);

boxes.forEach((box) => {
    observer.observe(box);
});


// gsap
gsap.registerPlugin(ScrollToPlugin);

gsap.to(".v-scroll",{ 
    yPercent:-300,
    duration:200,
    repeat: -1,
    ease: 'none',
});
